import axios from "../services/AxiosSetup";
import EventBus from "../plugins/event-bus";
import { stringToISODate } from "../helpers/date";
import Utils from "../utils";

//todo Arrumar Integração
import CotacaoRequest from './quotes/request/cotacao';

const api = axios.create({});

const Request = function(url, isNewBackend, method, data, cancelar) {
  if (!cancelar) {
    cancelar = axios.CancelToken.source();
  }

  this.hostApi = isNewBackend ? Utils.loadNewBaseUrl() : Utils.loadBaseUrl();

  const config = {
    url: this.hostApi + url,
    method: method,
    cancelToken: cancelar.token
  };

  if (method === 'post') {
    config.data = data;
  } else {
    config.params = data;
  }

  if (!['US', 'USDR'].includes(Utils.loadCountry())) {
    config.auth = {
      username: "gQMadftuMqUHe9uKhEMN6s2",
      password: "XQaFD5TBkPEtPHgLbFKPtfS"
    };
  }

  return api(config);
};

const RequestError = function(error) {
  if (!axios.isCancel(error)) {
    let mensagem = "";
    if (error.response) {
      mensagem = error.response.data.errors[0].message;
    } else if (error.request) {
      mensagem = error;
    } else {
      mensagem = error.message;
    }
    EventBus.$emit("criarAlerta", {
      snackbar: true,
      color: "error",
      text: mensagem
    });
    EventBus.$emit("change::isLoading", false);
  }
};

const RequestGetAll = function(context, request, apiUrl, commitFunction, isNewBackend, method = "post", cancelar) {
  if (!request) {
    request = {};
  }

  if (!isNewBackend) {
    isNewBackend = null;
  }

  if (method === "post" && request instanceof FormData) {
    request.append("USERID", Utils.loadUserId());
    request.append("SPRAS", "PT");
  } else {
    request.USERID = Utils.loadUserId();
    request.SPRAS = "PT";
  }

  let data = {}

  if (apiUrl === 'venusa/cotacao' && request.getParameters) {
    CotacaoRequest.clientes = CotacaoRequest.clientes.filter(item => {
      if (!/(Tigre|Garra|Fiera)/.test(item.CODE_CATEGORY)) {
        return false
      }

      if (!/(PREDIAL|RIEGO|INFRA)/.test(item.SALE_CHANNEL)) {
        return false
      }

      // if (!/(MAYORISTA|CONSTRUCTOR|FERRETERIA|DISTRIBUIDOR)/.test(item.CLASS_CODE)) {
      //   return false
      // }

      return true
    })

    data = CotacaoRequest
  } else {
    return this.Request(apiUrl, isNewBackend, method, request, cancelar)
        .then((response) => {
          context.commit(commitFunction, { list: response.data, request: request });
        })
        .catch(function(error) {
          RequestError(error);
        });
  }

  console.log('RequestGetAll.data', {list: data, request: request});
  context.commit(commitFunction, {list: data, request: request});
};

const PrepareGetAll = function(payload) {
  let { sortBy, sortDesc, page, itemsPerPage, dataInicial, dataFinal,
        status, material, cnpj, ordem, organizacao, pedido, statusPartida,
        notaFiscal, dataEmissaoInicial, dataEmissaoFinal, dataVencimentoInicial,
        dataVencimentoFinal, venctoStatus, dataPagIni, dataPagFim } = payload;
  page = parseInt(page) - 1;
  itemsPerPage = parseInt(itemsPerPage);
  const data_ini = stringToISODate(dataInicial);
  const data_fim = stringToISODate(dataFinal);
  const data_emissao_ini = stringToISODate(dataEmissaoInicial);
  const data_emissao_fim = stringToISODate(dataEmissaoFinal);
  const data_vencto_ini = stringToISODate(dataVencimentoInicial);
  const data_vencto_fim = stringToISODate(dataVencimentoFinal);
  const data_pagto_ini = stringToISODate(dataPagIni);
  const data_pagto_fim = stringToISODate(dataPagFim);

  return {
    SORT: sortBy[0],
    SORT_TYPE: sortDesc[0] ? "DESC" : "ASC",
    LIMIT: itemsPerPage,
    OFFSET: page * itemsPerPage,
    STATUS_PARTIDA: statusPartida,
    UNIDADEPAIS: Utils.loadCountry(),
    FILTRO: {
      PEDIDO: pedido,
      ORGANIZACAO: organizacao,
      CNPJ: cnpj,
      ORDEM: ordem,
      DATA_INI: data_ini,
      DATA_FIM: data_fim,
      DATA_CRIACAO_INI: data_ini,
      DATA_CRIACAO_FIM: data_fim,
      STATUS: status,
      MATERIAL: material,
      NOTA_FISCAL : notaFiscal,
      DATA_EMISSAO_INI : data_emissao_ini,
      DATA_EMISSAO_FIM : data_emissao_fim,
      DATA_VENCTO_INI : data_vencto_ini,
      DATA_VENCTO_FIM : data_vencto_fim,
      DATA_VENCTO_STATUS : venctoStatus,
      DATA_PAGTO_INI : data_pagto_ini,
      DATA_PAGTO_FIM : data_pagto_fim

    }
  };
};
const RequestGetById = function(context, request, apiUrl, commitFunction, isNewBackend) {
  if (!request) {
    request = {};
  }
  if (!isNewBackend) {
    isNewBackend = null;
  }
  request.USERID = Utils.loadUserId();
  request.SPRAS = "PT";
  this.Request(apiUrl, isNewBackend, "post", request)
    .then((response) => {
      context.commit(commitFunction, { row: response.data, request: request });
    })
    .catch(function(error) {
      RequestError(error);
    });
};

export default {
  Request,
  RequestGetById,
  RequestGetAll,
  PrepareGetAll
};